import React from "react";
import NotificationBell from "../issueReporting/components/NotificationBell";

const sidebarShow = (e) => {
  document.querySelector("body").classList.toggle("sidebar-show");
}

export default function HeaderMobile() {
  return (
    <div className="main-mobile-header doc-mobile-header d-flex align-items-center justify-content-between">
      <div onClick={sidebarShow} className="menu-link"><i className="ri-menu-line"></i></div>
      <div className="d-flex align-items-center">
        <NotificationBell mode="staff" />
      </div>
    </div>
  )
}
